import React from "react";
import { NavLink } from "react-router-dom";
import Slider from "react-slick";

import styles from "./styles";
import useGlobal from "../../store";
import * as Config from "../../helper/Configs";

const settings = {
	dots: false,
	infinite: true,
	speed: 1200,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 3500,
	adaptiveHeight: true,
	swipeToSlide: true,
	pauseOnHover: false
};

export default function Banner(props) {
	const classes = styles();
	const [globalState, globalActions] = useGlobal();
	const { contactUs } = globalState.cmsContext;

	return (
		<div className={classes.mainslider}>
			<div className="responsiveLogo">
				<NavLink to="/">
					<img src={`${Config.MEDIA_URL}images/${contactUs.logo}`} />
				</NavLink>
			</div>
			<Slider {...settings}>
				{props.type == 'home' ?
					props.banners.map((banner, key) => (
						<div className={classes.mainslider} key={key}>
							<img src={`${Config.MEDIA_URL}images/${banner.image}`} />
						</div>
					))
					:
					props.resort.banners.map((banner, key) => (
						<div className={classes.bannerBlock} key={key}>
							<div className={classes.bannerText}>{props.resort.name}</div>
							<img src={`${Config.MEDIA_URL}images/${banner.image}`} />
						</div>
					))
				}
			</Slider>
			<div className="clear"></div>
		</div>
	);
}
